import React from 'react'

import DetailItem, { Props as DetailItemProps } from './DetailItem'
import { DetailsContainer } from './styled-components'

type Props = {
  details: DetailItemProps[]
}

const DetailsList: React.SFC<Props> = ({ details }) => (
  <>
    <DetailsContainer>
      {details.map((detail, index) => (
        <DetailItem
          key={index}
          text={detail.text}
          imagePath={detail.imagePath}
          altText={detail.altText}
        />
      ))}
    </DetailsContainer>
  </>
)

export default DetailsList
